import { render, staticRenderFns } from "./FieldInternational.vue?vue&type=template&id=36d6fd33&"
import script from "./FieldInternational.vue?vue&type=script&lang=ts&"
export * from "./FieldInternational.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports